import React from "react";
import type { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import Icon from "src/components/icon";
import { scrollTo } from "src/utils/scroll";

export default class DatePickerCustomHeader extends React.Component<{
    monthsShown: number,
    device: "mobile" | "desktop",
    locale: string,
    cursorPosition: "right" | "side_to_side" | undefined;
    style: any,
} & ReactDatePickerCustomHeaderProps > {
    divRef = React.createRef<HTMLDivElement>();

    get chevronLeftHidden() {
        const { monthsShown, device, customHeaderCount } = this.props
        return monthsShown && monthsShown === 1 ? false : device === "desktop" && customHeaderCount === 1
    }

    get chevronRightHidden() {
        const { monthsShown, device, customHeaderCount } = this.props
        return  monthsShown && monthsShown === 1 ? false : device === "desktop" && customHeaderCount === 0
    }

    scrollIntoView(): number {
        if (!this.divRef.current) return window.scrollY;
        const yOffset = -150;
        const y = this.divRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
        const currentPos = window.scrollY;
        scrollTo({top: y, behavior: 'auto'});
        return currentPos;
    }

    renderHeader(){
        const { increaseMonth, decreaseMonth, locale, monthDate, cursorPosition = "side_to_side" } = this.props;
        const monthClassname = cursorPosition === "side_to_side" ? "flex-1" : "mr-auto ml-2"

        const chevronRight = (
            <button
                aria-label="Next Month"
                className="react-datepicker__navigation react-datepicker__navigation--next !relative"
                style={this.chevronRightHidden ? { visibility: "hidden" } : undefined}
                onClick={increaseMonth}
            >
                <Icon icon="ChevronRight" className="h-6 w-6 text-[color:var(--cal-chevron-color)]" />
            </button>
        )

        const chevronLeft = (
            <button
                    aria-label="Previous Month"
                    className="react-datepicker__navigation react-datepicker__navigation--previous !relative"
                    style={this.chevronLeftHidden ? { visibility: "hidden" } : undefined}
                    onClick={decreaseMonth}
                >
                <Icon icon="ChevronLeft" className="h-6 w-6 text-[color:var(--cal-chevron-color)]" />
            </button>
        )

        const month = <span className={`monthlabel font-semibold ${monthClassname}`}>
                {monthDate.toLocaleString(locale, { month: "long", year: "numeric" })}
            </span>


        if (cursorPosition === "side_to_side") return <div className="flex w-full items-center">{chevronLeft}{month}{chevronRight}</div>
        return <div className="flex w-full items-center">{month}{chevronLeft}{chevronRight}</div>
    }

    render() {
        return (
        <div ref={this.divRef} style={this.props.style} className="flex flex-row items-center py-2">
        {
            this.renderHeader()
        }
        </div>
        );
    };
}